import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonInput,
  IonTextarea,
  IonButton,
  IonChip,
  IonIcon,
  IonAlert,
} from '@ionic/react';
import { addCircleOutline, closeCircle } from 'ionicons/icons';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { getPost, updatePost } from '../actions/post';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditPost = ({ post: { post, loading }, getPost, updatePost, match }) => {
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [topic, setTopic] = useState('');
  const [desc, setDesc] = useState('');
  const [content, setContent] = useState('');
  const [tag, setTag] = useState('');
  const [tags, setTags] = useState(['Easy', 'Hard']);
  const [modules] = useState({
    syntax: true,
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ align: [] }],
      [{ color: [] }],

      ['code-block', 'link', 'image'],
    ],
  });

  const [formats] = useState([
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'script',
    'bullet',
    'align',
    'color',
    'code-block',
    'link',
    'image',
  ]);
  const addTag = () => {
    if (tag) setTags((tags) => [...tags, tag]);
    setTag('');
  };

  useEffect(() => {
    getPost(match.params.id);
    setTitle(loading || !post.title ? '' : post.title);
    setTopic(loading || !post.topic ? '' : post.topic);
    setDesc(loading || !post.desc ? '' : post.desc);
    setContent(loading || !post.content ? '' : post.content);
    setTags(loading || !post.tags.length ? [] : post.tags);
    // eslint-disable-next-line
  }, [loading]);

  const handleEdit = () => {
    if (!title) {
      setMessage('Please enter a title');
      setIsError(true);
      return;
    }

    if (!topic) {
      setMessage('Please enter a topic');
      setIsError(true);
      return;
    }
    if (!desc) {
      setMessage('Please enter description');
      setIsError(true);
      return;
    }
    if (desc.length < 10) {
      setMessage('Description should be atleast 10 characters');
      setIsError(true);
      return;
    }
    if (!content) {
      setMessage('Please enter post content');
      setIsError(true);
      return;
    }
    if (tags.length < 1) {
      setMessage('Please add tags');
      setIsError(true);
      return;
    }

    const editData = {
      title: title,
      topic: topic,
      desc: desc,
      content: content,
      tags: tags,
    };

    updatePost(match.params.id, editData);
    window.location = `/post/${match.params.id}`;
  };

  return (
    <IonContent id='submit'>
      <IonAlert
        isOpen={isError}
        onDidDismiss={() => setIsError(false)}
        cssClass='my-custom-class'
        header={'Error!'}
        message={message}
        buttons={['Dismiss']}
      />
      <IonHeader>
        <IonToolbar color='secondary'>
          <IonTitle>Submit a Post</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonRow className='ion-justify-content-center' style={{ marginTop: '4%' }}>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem>
            <IonLabel position='stacked'>Title</IonLabel>
            <IonInput
              type='Title'
              value={title}
              onIonChange={(e) => setTitle(e.detail.value)}
              style={{ marginTop: '5px' }}
              placeholder='Enter title'
              required={true}
            ></IonInput>
          </IonItem>
        </IonCol>
      </IonRow>
      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem>
            <IonLabel position='stacked'>Topic</IonLabel>
            <IonInput
              type='Topic'
              value={topic}
              onIonChange={(e) => setTopic(e.detail.value)}
              style={{ marginTop: '5px' }}
              placeholder='Enter topic'
              required={true}
            ></IonInput>
          </IonItem>
        </IonCol>
      </IonRow>
      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem>
            <IonLabel position='stacked'>Description</IonLabel>
            <IonTextarea
              type='Description'
              value={desc}
              onIonChange={(e) => setDesc(e.detail.value)}
              style={{ marginTop: '5px' }}
              placeholder='Enter description'
              rows={4}
              required={true}
            ></IonTextarea>
          </IonItem>
        </IonCol>
      </IonRow>

      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem lines='none'>
            <IonLabel position='floating'>Content</IonLabel>
          </IonItem>
          <ReactQuill
            name='content'
            value={content}
            onChange={(e) => setContent(e)}
            modules={modules}
            formats={formats}
            theme='snow'
            style={{ paddingLeft: '20px', width: '95%' }}
            required={true}
          />
        </IonCol>
      </IonRow>

      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='8' sizeMd='auto'>
          <IonItem lines='none'>
            <IonLabel position='floating'>Tags</IonLabel>
          </IonItem>
          <IonChip color='secondary' style={{ marginLeft: '20px' }}>
            <IonInput
              style={{ marginLeft: '5px' }}
              size='3'
              name='tag'
              value={tag}
              onIonChange={(e) => setTag(e.detail.value)}
              className='margin-horizontal'
            ></IonInput>
            <IonIcon icon={addCircleOutline} onClick={addTag} />
          </IonChip>
          {tags.map((t) => (
            <IonChip color='secondary' style={{ marginLeft: '18px' }}>
              <IonLabel color='dark'>{t}</IonLabel>
              <IonIcon icon={closeCircle} onClick={() => setTags(tags.filter((tag) => tag !== t))} />
            </IonChip>
          ))}
        </IonCol>
      </IonRow>
      <IonRow className='ion-justify-content-center'>
        <IonCol sizeLg='3' sizeMd='auto'>
          <IonButton expand='block' style={{ margin: '48px 0' }} onClick={handleEdit}>
            Save
          </IonButton>
        </IonCol>
      </IonRow>
    </IonContent>
  );
};

EditPost.propType = {
  getPost: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
  post: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  post: state.post,
});

export default connect(mapStateToProps, { updatePost, getPost })(withRouter(EditPost));
